module.exports = __webpack_public_path__ + "img/1.2e9552ce.jpg";